import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { observer } from 'mobx-react';
import React from 'react';

import { IUnitCardModel } from '../../../../../service/unit/interface/IUnitCardModel';
import { UnitCardHeader } from './UnitCardHeader';
import { UnitCardLangs } from './UnitCardLangs';
import { UnitCardStats } from './UnitCardStats';
import { Colors } from '../../../../design/color/Colors';

const useStyles = makeStyles(() => ({
  card: {
    background: Colors.bgElevated,
    borderColor: Colors.border,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: '16px',
    position: 'relative',
    paddingRight: '16px',
    cursor: 'pointer',
    '&:hover': { background: Colors.bgSurface },
  },
  flexCenter: { display: 'flex', alignItems: 'center' },
  content: { display: 'flex', flexDirection: 'column', flex: '0 0 70%' },
  innerPad: { padding: '24px 24px 0 24px', minHeight: '168px', paddingBottom: '32px' },
  desc: { opacity: 0.7, marginBottom: '32px' },
  imgContainer: { flex: '0 0 30%', height: '185px', position: 'relative' },
  imgCover: {
    width: '100%',
    height: '100%',
    objectFit: 'cover' as const,
    position: 'absolute' as const,
    top: 0,
    left: 0,
  },
}));

export interface IUnitListAdminCardProperties {
  unit: IUnitCardModel;
  handleEdit: (unitId: string) => void;
  handleDelete: (unitId: string) => void;
  handlePublish: (unitId: string) => void;
  handleUnpublish: (unitId: string) => void;
}

export const UnitListAdminCard = observer(
  ({ unit, handleEdit, handleDelete, handlePublish, handleUnpublish }: IUnitListAdminCardProperties) => {
    const classes = useStyles();

    return (
      <Box className={classes.card}>
        <Box id={unit.id} className={classes.flexCenter}>
          <Box className={classes.content}>
            <Box className={classes.innerPad}>
              <UnitCardHeader
                unit={unit}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
                handlePublish={handlePublish}
                handleUnpublish={handleUnpublish}
              />
              <Box className={classes.desc}>{unit.settings.description}</Box>
              <UnitCardStats unit={unit} />
              {unit?.practice?.isEnabled && <UnitCardLangs unit={unit} />}
            </Box>
          </Box>

          <Box className={classes.imgContainer}>
            <img
              src={unit.settings.preview?.data || '/pictures/unit-cover-default.png'}
              alt="unit-cover"
              className={classes.imgCover}
              style={!unit.settings.preview?.data ? { filter: Colors.logoFilter } : undefined}
            />
          </Box>
        </Box>
      </Box>
    );
  },
);
